/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Ask_Questions_Status_SubmittedInputs */

const es_components_ask_questions_status_submitted = /** @type {(inputs: Components_Ask_Questions_Status_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas respondidas`)
};

const en_components_ask_questions_status_submitted = /** @type {(inputs: Components_Ask_Questions_Status_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions answered`)
};

/**
* | output |
* | --- |
* | "Questions answered" |
*
* @param {Components_Ask_Questions_Status_SubmittedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_ask_questions_status_submitted = /** @type {((inputs?: Components_Ask_Questions_Status_SubmittedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Ask_Questions_Status_SubmittedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_ask_questions_status_submitted(inputs)
	return en_components_ask_questions_status_submitted(inputs)
});
export { components_ask_questions_status_submitted as "components.ask_questions.status.submitted" }